import { useSession } from '@/hooks/useSession';
import { TRANSMITTER_PERMISSIONS } from '../permissions';

type TransmitterPermission =
  (typeof TRANSMITTER_PERMISSIONS)[keyof typeof TRANSMITTER_PERMISSIONS];

const PERMISSION_BYPASS_ROLES = new Set(['full_admin', 'director']);

export function useHasTransmitterPermission(permission: TransmitterPermission): boolean {
  const { user } = useSession();
  if (!user) return false;
  if (user.postgres_roles.some((role) => PERMISSION_BYPASS_ROLES.has(role))) {
    return true;
  }
  return user.permission_strings?.includes(permission) ?? false;
}

